module.exports = __webpack_public_path__ + "images/stickers/taco-proto@2x.51def85cdcf3c1a58cb1.png";